"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateDifTranslations = exports.DateDifHF = void 0;
const hyperformula_1 = require("hyperformula");
const moment_1 = __importDefault(require("moment"));
class DateDifHF extends hyperformula_1.FunctionPlugin {
    datedif(syntaxTree, state) {
        return this.runFunction(syntaxTree.args, state, this.metadata('DATEDIF'), (firstDate, secondDate) => {
            const { result } = this.daysDiff(firstDate, secondDate);
            return result;
        });
    }
    daysDiff(firstDate, secondDate) {
        if (!firstDate || !secondDate) {
            return { result: 0 };
        }
        const { start, end } = this.getParsedDate(firstDate, secondDate);
        const days = (0, moment_1.default)(end).diff(start, 'days', true);
        return { result: Number(Math.abs(days).toFixed(0)) };
    }
    getParsedDate(firstDate, secondDate) {
        const startSimpleDateTime = this.dateTimeHelper.numberToSimpleDate(firstDate);
        const endSimpleDateTime = this.dateTimeHelper.numberToSimpleDate(secondDate);
        return {
            start: (0, moment_1.default)(Object.assign(Object.assign({}, startSimpleDateTime), { month: startSimpleDateTime.month - 1 })),
            end: (0, moment_1.default)(Object.assign(Object.assign({}, endSimpleDateTime), { month: endSimpleDateTime.month - 1 })),
        };
    }
}
exports.DateDifHF = DateDifHF;
DateDifHF.implementedFunctions = {
    DATEDIF: {
        method: 'datedif',
        parameters: [{ argumentType: 'STRING' }, { argumentType: 'STRING' }],
    },
};
exports.DateDifTranslations = {
    enGB: {
        DATEDIF: 'DATEDIF',
    },
};
